module.exports = __webpack_public_path__ + "img/lv.da4e783b.svg";